module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "oleksandr_filts.260cc6aa.png" + "?" + Date.now();